/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Integrations_Zotero_Disconnect_ErrorInputs */

const en_settings_integrations_zotero_disconnect_error = /** @type {(inputs: Settings_Integrations_Zotero_Disconnect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to disconnect Zotero`)
};

const es_settings_integrations_zotero_disconnect_error = /** @type {(inputs: Settings_Integrations_Zotero_Disconnect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo desconectar Zotero`)
};

/**
* | output |
* | --- |
* | "Failed to disconnect Zotero" |
*
* @param {Settings_Integrations_Zotero_Disconnect_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_zotero_disconnect_error = /** @type {((inputs?: Settings_Integrations_Zotero_Disconnect_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_Zotero_Disconnect_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_zotero_disconnect_error(inputs)
	return en_settings_integrations_zotero_disconnect_error(inputs)
});